<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-card
          raised
        >
          <v-card-title primary-title>
            <v-row
              justify="space-around"
              align="center"
              class="text-center"
              no-gatter
            >
              <v-col>
                <v-icon
                  x-large
                  class="blue--text text--darken-2"
                >
                  mdi-numeric-4-box-outline
                </v-icon>
              </v-col>

              <v-col>
                <v-icon
                  x-large
                  class="blue--text text--darken-2"
                >
                  mdi-numeric-0-box-outline
                </v-icon>
              </v-col>

              <v-col>
                <v-icon
                  x-large
                  class="blue--text text--darken-2"
                >
                  mdi-numeric-4-box-outline
                </v-icon>
              </v-col>

              <v-col cols="12" class="display-1 text-center">
                404 - Seite nicht gefunden!
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="text-center body-2">
            <p>Die Seite die Du suchst gibt es hier nicht.</p>
            <p>Vielleicht hast Du einen veralteten Link genutzt.</p>

            <p><strong>ACHTUNG: DAS SPIEL IST IN DER ENTWICKLUNG UND NOCH NICHT FERTIG.</strong></p>
            <p><strong>SEITEN DIE GEHEN; WERDEN BEI DEN ÄNDERUNGEN ANGEZEIGT</strong></p>
            <p>
              Melde diesen Fehler bitte per E-Mail an webmaster@kegelmanager.de<br>
              und erhalte 1000 TP auf Dein Girokonto gutgeschrieben. Verwende dazu Deine registrierte E-Mail-Adresse
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound404',
  metaInfo: {
    title: '404 - Seite nicht gefunden'
  }
}
</script>
